/**
 * Template Loader
 * @author Rhys Lloyd
 */

//
// Utilities
import debug from "debug";
const MODULE_NAME = 'templace-loader';
const log = debug(MODULE_NAME);

import memoize from 'lodash/memoize';

/**
 * Load a template from a selector.
 * @type {Function}
 * @param selector - Selector for template
 * @param context - Optional context for the selector
 * @returns {String} - The template
 */
export const loadTemplate = memoize((selector, context) => {
	log('loadTemplate() loading template', selector, 'with context', context);
	return $(selector, context).html();
});



// WEBPACK FOOTER //
// ./project/client/src/core/services/template-loader.js